import { UserAccount } from "@src/@types/UserAccount";
import axiosInstance from "@src/configs/axiosConfig";
import {
  handleSetOnLoading,
  handleUserAccount,
} from "@src/redux/reducers/userAccount";
import { useDispatch } from "react-redux";

export const FETCH_DATA_REQUEST = "FETCH_DATA_REQUEST";
export const FETCH_DATA_SUCCESS = "FETCH_DATA_SUCCESS";
export const FETCH_DATA_FAILURE = "FETCH_DATA_FAILURE";

function useFetchData() {
  const dispatch = useDispatch();
  const fetchUserAccountData = () => {
    console.log("start");
    axiosInstance
      .get("/user")
      .then((response) => {
        let userAccount: UserAccount = response.data;
        console.log("user back");
        console.log(userAccount);
        dispatch(handleUserAccount(userAccount));
        dispatch(handleSetOnLoading(false));
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {});
  };

  /***
   *  Obtém o código passando a string do site.
   * @param site string do domínio
   * @param Function setter do código de instalação.
   * */
  const fetchCode = async (_site: string, setCode: Function) => {
    const script = `<script\n  onload="assistive.init({})"\n  src="https://cdn.assistive.com.br/plugin/AssistiveWebPlugin.js"\n  charset="UTF-8"\n  type="text/javascript"\n  async="true"\n  data-astv-account="e99a18c428cb38d5f26087dcf8427e"\n></script>`;
    dispatch(handleSetOnLoading(false));
    setCode(script);
    return script;
  };

  return { fetchUserAccountData, fetchCode };
}

export default useFetchData;
